<template>
    <div>
      <translator-list></translator-list>
    </div>
  </template>
  
  <script>
  export default {
  }
  </script>
  
  
  